import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { API } from "@/lib/api";

export const useAvailability = () =>
  useQuery({
    queryKey: ["availability"],
    queryFn: async () => (await axios.get(`${API}/availability`)).data,
    staleTime: 5 * 60 * 1000,
  });
